import { render } from "./MatchSideInfoWeb.vue?vue&type=template&id=02c5251e&scoped=true"
import script from "./MatchSideInfoWeb.vue?vue&type=script&lang=js"
export * from "./MatchSideInfoWeb.vue?vue&type=script&lang=js"

import "./MatchSideInfoWeb.vue?vue&type=style&index=0&id=02c5251e&scoped=true&lang=css"
import "./MatchSideInfoWeb.vue?vue&type=style&index=1&id=02c5251e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c5251e"]])

export default __exports__